import { http } from "utils/http";

export function getQiniuToken(): Promise<qiniu.IToken> {
    return http.get('/api/utils/get-qiniu-token');
}